import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IRound, IRoundsStore} from "data/stores/rounds/rounds.store";
import type {IHeavyPredictionsStore} from "data/stores/heavy_predictions/heavy_predictions.store";
import type {ITournamentsStore} from "data/stores/tournaments/tournaments.store";
import {TournamentStatus} from "data/enums";

interface IProps {
	roundId: number;
}
export interface IRoundNavItemController extends ViewController<IProps> {
	readonly i18n: ILocalizationStore;

	get playOffRounds(): IRound[];
	get selectedRoundId(): number;
	get isAllPredictionsSelect(): boolean;

	onChangeRound: (roundId: number) => void;
}

@injectable()
export class RoundNavItemController implements IRoundNavItemController {
	@observable private _roundId: number = 0;

	get playOffRounds() {
		return this._roundStore.playoffRoundsList;
	}

	get selectedRoundId() {
		return this._roundStore.selectedRoundId;
	}

	private get predictionByRound() {
		return this._hpStore.predictionByRoundId(this._roundId);
	}

	private get matchesByRoundId() {
		return this._tournamentStore.tournaments.filter(
			(tournament) =>
				tournament.roundId === this._roundId &&
				tournament.status === TournamentStatus.Scheduled
		);
	}

	get isAllPredictionsSelect() {
		return this.predictionByRound.length >= this.matchesByRoundId.length;
	}

	constructor(
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore,
		@inject(Bindings.RoundsStore) private _roundStore: IRoundsStore,
		@inject(Bindings.HeavyPredictionsStore) private _hpStore: IHeavyPredictionsStore,
		@inject(Bindings.TournamentsStore) private _tournamentStore: ITournamentsStore
	) {
		makeAutoObservable(this);
	}

	onChangeRound = (roundId: number) => {
		this._roundStore.setSelectedRoundId(roundId);
	};

	init({roundId}: IProps) {
		this._roundId = roundId;
	}
}
